'use strict';

angular.module('myConsultApp')
	 .directive("customTooltip", function () {
    return {
        link: function (scope, element, attrs) {
			
            $(element).on("touchstart click", function (e) {
				e.stopPropagation(); 
				e.preventDefault();
				var thisElement = $(this);

				$('.customtooltip').not(thisElement).find("span").remove();
				$('.customtooltip').not(thisElement).parent().removeClass('openToolTip');
				
				if($(this).find("span").length == 0){
					$(this).append("<span>"+ attrs.customTooltip +"</span>");
					$(this).parent().addClass('openToolTip');
				}else{
					$(this).find("span").remove();
					$(this).parent().removeClass('openToolTip');
				}
            });
            
            scope.$on("$destroy", function () {
                $(element).off("click");
                $(element).off("touchstart");
            });


			//note: Should we consider removing this event after the element is destroyed?
			$('body').on('touchstart click', function(e){ 
				$('.customtooltip').each(function(i){
					$(this).find("span").remove();
				});   
			});

        }
	
    };
});